import { render, staticRenderFns } from "./ManufacturingItems.vue?vue&type=template&id=1d1f79c1&scoped=true&"
import script from "./ManufacturingItems.vue?vue&type=script&lang=js&"
export * from "./ManufacturingItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1f79c1",
  null
  
)

export default component.exports